import React from 'react';

const Body = () => (
    <>
        <div className="aboutTopPad"></div>
        <h2>The JD Foundation | Latest News</h2>
        <br />
        <h2 className="underline font-20">
            JD Foundation announces Stephen Lawrence Charitable Trust as a new Partner
        </h2>
        <br />
        <br />
        The JD Foundation is excited to announce that following the JD Group Employee choice vote,
        the JD Foundation has secured a two year partnership with the Stephen Lawrence Charitable
        Trust (SLCT).
        <br />
        <br />
        As with all our partners, our partnership is not just about the monetary donations, but
        includes working with the charity and supporting their work to create a fairer and more
        inclusive society. We will be working with SLCT on an exciting recruitment project that aims
        to connect talented and ambitious young people with opportunities across various industries
        and with employers that would normally be out of their reach. These opportunities include
        mentoring, work placements, internships and employment. <br />
        <br />
        We very much look forward to working with SLCT to create a better future for all.
        <br />
        <br />
        <img
            className="full"
            src="https://files.jdplc.com/images/about/jd-foundation-SLCT.jpg"
            alt=""
        />
        <br />
        <br />
        <h2 className="underline font-20">New Charity Partnerships</h2>
        <br />
        <br />
        In 2020 the JD Foundation committed its support to seventeen charity partners across the UK.
        The selection of charity partners the Foundation support outlines the commitment to helping
        youth communities within the UK. <br />
        <br />A rise in social mobility issues, an increase in population and annual government
        spending cuts has led to many individuals and community groups setting up charities and
        social enterprises to bridge the gap and help support disadvantage communities around the
        UK. Whether that be tackling youth homelessness or unemployment, providing support for
        families dealing with terminal illness or bereavement, and even voluntary organisations
        leading life-saving rescues in remote locations – the JD Foundation want to be there to
        support them.{' '}
        <ul className="list">
            <li>Papyrus Prevention of Young Suicide</li>
            <li>Cardiac Risk in the Young - the Aaron James Dixon Memorial Fund</li>
            <li>Kidscape</li>
            <li>The Wellspring</li>
            <li>Salford Foundation</li>
            <li>Manchester Youth Zone</li>
            <li>Hide Out Youth Zone</li>
            <li>Sacriston Youth Project</li>
            <li>Bolton Wanderers Community Trust</li>
            <li>Smiling Families</li>
            <li>Young Minds</li>
            <li>Sport 4 Life</li>
            <li>City Hearts</li>
            <li>Once Upon a Smile</li>
            <li>Buddies of the Birches</li>
            <li>Mountain Rescue England &amp; Wales</li>
            <li>Scottish Mountain Rescue</li>
        </ul>
        <br />
        <h2 className="underline font-20">City Hearts</h2>
        <br />
        <br />
        The JD Foundation are very excited to introduce City Hearts as one of our new charity
        partners for 2020. The relationship between City Hearts and the JD Foundation gives a unique
        opportunity for JD Sports Plc. to work with the charity on their Bright Future Employment
        programme which assists survivors of Modern Slavery to rebuild their lives through support
        and employment. JD Sports will be working with the Bright Future Programme, providing
        employment placements within the business organisation, leading to the opportunity of
        permanent employment. The JD Foundation will support the charity itself with funding to
        support these and other individuals on their journey to rebuild their lives.
        <br />
        <br />
        <h2 className="underline font-20">The JD Foundation Ball – October 2019</h2>
        <h4>
            <i>
                October 2019 saw the 4th anniversary of the JD Foundation and we celebrated in style
                by hosting our 3rd fundraising ball
            </i>
        </h4>
        <br />
        An incredible £125,000 was raised on the evening for The JD Foundation. We are excited to
        announce that this will allow us to fund a new grant scheme which we plan to launch in the
        second part of 2020. The grant scheme will focus on homelessness and mental health charities
        which affect so many people’s lives nationally and allow greater access for smaller, lesser
        known charities, who work tirelessly in local communities, to much needed funding.
        <br />
        <br />
        The ball was held at Old Trafford Cricket Ground, hosting a drinks reception and a gala
        dinner. Our special guests included performances from Suggs, the cast of the West End
        musical, We Will Rock You and Alex Birtwell and his band. A surprise performance from Luci
        Ormrod, JD’s own label Menswear designer, surprised colleagues and guests alike with a
        fantastic version of “Climb” by Miley Cyrus, to showcase our charity weekend held in the
        Summer with young people from 15 of our charities.
        <br />
        <br />
        John Mcavoy, (Iron Bars to Iron Man) talked about his early life, how sport changed his life
        and how the JD Foundation can and does Change Lives. John was interviewed by TV celebrity,
        Radzi Chinyanganya.
        <br />
        <br />
        We would like to thank all the suppliers of the JD Group for their support on the evening
        and in raising so much money for the JD foundation.
        <br />
        <br />{' '}
        <div className="carousel" id="october-ball">
            {' '}
            <div className="slide slide-1"></div> <div className="slide slide-2"></div>{' '}
            <div className="slide slide-3"></div> <div className="slide slide-4"></div>{' '}
            <div className="slide slide-5"></div> <div className="slide slide-6"></div>{' '}
            <div className="slide slide-7"></div> <div className="slide slide-8"></div>{' '}
            <div className="slide slide-9"></div> <div className="slide slide-10"></div>{' '}
            <div className="slide slide-11"></div> <div className="slide slide-12"></div>{' '}
            <div className="slide slide-13"></div> <div className="slide slide-14"></div>{' '}
            <div className="slide slide-15"></div> <div className="slide slide-16"></div>{' '}
            <div className="slide slide-17"></div> <div className="slide slide-18"></div>{' '}
            <div className="slide slide-19"></div> <div className="slide slide-20"></div>{' '}
        </div>
    </>
);

export const content = {
    image: 'https://files.jdplc.com/images/about/jd-foundation-latest-news.jpg',
    body: Body,
};
